module.exports = __webpack_public_path__ + "img/one_13.6813e13a.png";